import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'

import { Grid, Button, ExpansionPanelDetails, Typography, ListItem } from '@material-ui/core'
import { EditableSwitch } from '../common/EditableComponents'
import { updateShopFeatures } from '../../actions/shop'

class OnFleetSettingInfoOrdenNotes extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      enableSubTotal: (props.onfleetSettings && props.onfleetSettings.enableSubTotal) || false,
      enableApplicableDiscountAmount:
        (props.onfleetSettings && props.onfleetSettings.enableApplicableDiscountAmount) || false,
      enableApplicableExciseTaxes:
        (props.onfleetSettings && props.onfleetSettings.enableApplicableExciseTaxes) || false,
      enableTotalTaxORGranularTax:
        (props.onfleetSettings && props.onfleetSettings.enableTotalTaxORGranularTax) || false,
      enableApplicablePromotionsName:
        (props.onfleetSettings && props.onfleetSettings.enableApplicablePromotionsName) || false,
      enableApplicableRewardsName:
        (props.onfleetSettings && props.onfleetSettings.enableApplicableRewardsName) || false,
      enableApplicableOrderTags:
        (props.onfleetSettings && props.onfleetSettings.enableApplicableOrderTags) || false,
      enablePaidStatus: (props.onfleetSettings && props.onfleetSettings.enablePaidStatus) || false,
      enableProductsValue:
        (props.onfleetSettings && props.onfleetSettings.enableProductsValue) || false,
      enableBrand: (props.onfleetSettings && props.onfleetSettings.enableBrand) || false,
      enableProductName:
        (props.onfleetSettings && props.onfleetSettings.enableProductName) || false,
      enableWPU: (props.onfleetSettings && props.onfleetSettings.enableWPU) || false,
      enableProductSKU: (props.onfleetSettings && props.onfleetSettings.enableProductSKU) || false,
      enableBatchUID: (props.onfleetSettings && props.onfleetSettings.enableBatchUID) || false,
      enableBatchTrackingSystemLabel:
        (props.onfleetSettings && props.onfleetSettings.enableBatchTrackingSystemLabel) || false,
      enableDiscount: (props.onfleetSettings && props.onfleetSettings.enableDiscount) || false,
      enableDiscountNotes:
        (props.onfleetSettings && props.onfleetSettings.enableDiscountNotes) || false,
    }
  }

  updateShopFeatures = (onfleetSettings) => {
    const { shopFeatures = [] } = this.props

    shopFeatures.onfleetSetting = onfleetSettings

    this.props.dispatch(updateShopFeatures(shopFeatures)).then((res) => {
      this.toggleEdit()
    })
  }

  onChange = (key, value, isSelect) => (e) => {
    if (isSelect) {
      this.setState({ [key]: e.target.value })
    } else {
      this.setState({ [key]: !value })
    }
  }

  toggleEdit = () => {
    this.setState({
      editMode: !this.state.editMode,
      enableSubTotal:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableSubTotal) || false,
      enableApplicableDiscountAmount:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableApplicableDiscountAmount) ||
        false,
      enableApplicableExciseTaxes:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableApplicableExciseTaxes) ||
        false,
      enableTotalTaxORGranularTax:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableTotalTaxORGranularTax) ||
        false,
      enableApplicablePromotionsName:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableApplicablePromotionsName) ||
        false,
      enableApplicableRewardsName:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableApplicableRewardsName) ||
        false,
      enableApplicableOrderTags:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableApplicableOrderTags) ||
        false,
      enablePaidStatus:
        (this.props.onfleetSettings && this.props.onfleetSettings.enablePaidStatus) || false,
      enableProductsValue:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableProductsValue) || false,
      enableBrand: (this.props.onfleetSettings && this.props.onfleetSettings.enableBrand) || false,
      enableProductName:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableProductName) || false,
      enableWPU: (this.props.onfleetSettings && this.props.onfleetSettings.enableWPU) || false,
      enableProductSKU:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableProductSKU) || false,
      enableBatchUID:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableBatchUID) || false,
      enableBatchTrackingSystemLabel:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableBatchTrackingSystemLabel) ||
        false,
      enableDiscount:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableDiscount) || false,
      enableDiscountNotes:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableDiscountNotes) || false,
    })
  }

  onUpdate = () => {
    const { onfleetSettings = {} } = this.props
    const {
      enableSubTotal,
      enableApplicableDiscountAmount,
      enableApplicableExciseTaxes,
      enableTotalTaxORGranularTax,
      enableApplicablePromotionsName,
      enableApplicableRewardsName,
      enableApplicableOrderTags,
      enablePaidStatus,
      enableProductsValue,
      enableBrand,
      enableProductName,
      enableWPU,
      enableProductSKU,
      enableBatchUID,
      enableBatchTrackingSystemLabel,
      enableDiscount,
      enableDiscountNotes,
    } = this.state
    onfleetSettings.enableSubTotal = enableSubTotal
    onfleetSettings.enableApplicableDiscountAmount = enableApplicableDiscountAmount
    onfleetSettings.enableApplicableExciseTaxes = enableApplicableExciseTaxes
    onfleetSettings.enableTotalTaxORGranularTax = enableTotalTaxORGranularTax
    onfleetSettings.enableApplicablePromotionsName = enableApplicablePromotionsName
    onfleetSettings.enableApplicableRewardsName = enableApplicableRewardsName
    onfleetSettings.enableApplicableOrderTags = enableApplicableOrderTags
    onfleetSettings.enablePaidStatus = enablePaidStatus
    onfleetSettings.enableProductsValue = enableProductsValue
    onfleetSettings.enableBrand = enableBrand
    onfleetSettings.enableProductName = enableProductName
    onfleetSettings.enableWPU = enableWPU
    onfleetSettings.enableProductSKU = enableProductSKU
    onfleetSettings.enableBatchUID = enableBatchUID
    onfleetSettings.enableBatchTrackingSystemLabel = enableBatchTrackingSystemLabel
    onfleetSettings.enableDiscount = enableDiscount
    onfleetSettings.enableDiscountNotes = enableDiscountNotes

    this.updateShopFeatures(onfleetSettings)
  }

  render() {
    const {
      editMode = false,
      enableSubTotal = false,
      enableApplicableDiscountAmount = false,
      enableApplicableExciseTaxes = false,
      enableTotalTaxORGranularTax = false,
      enableApplicablePromotionsName = false,
      enableApplicableRewardsName = false,
      enableApplicableOrderTags = false,
      enablePaidStatus = false,
      enableProductsValue = false,
      enableBrand = false,
      enableProductName = false,
      enableWPU = false,
      enableProductSKU = false,
      enableBatchUID = false,
      enableBatchTrackingSystemLabel = false,
      enableDiscount = false,
      enableDiscountNotes = false,
    } = this.state

    return (
      <ExpansionPanelDetails>
        <div className="full-width">
          {!editMode ? (
            <Button className="primary-button pull-right" onClick={this.toggleEdit}>
              {' '}
              Edit{' '}
            </Button>
          ) : (
            <div className="pull-right margin-bottom-small">
              <Button className="primary-button margin" onClick={this.onUpdate}>
                Save
              </Button>
              <Button className="danger-button margin" onClick={this.toggleEdit}>
                Cancel
              </Button>
            </div>
          )}
          <Grid container className="listing-spacing">
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Subtotal</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableSubTotal}
                      onChange={this.onChange('enableSubTotal', enableSubTotal)}
                      valueToRender={enableSubTotal ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Applicable Discount Amount</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableApplicableDiscountAmount}
                      onChange={this.onChange(
                        'enableApplicableDiscountAmount',
                        enableApplicableDiscountAmount,
                      )}
                      valueToRender={enableApplicableDiscountAmount ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Applicable Excise Taxes</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableApplicableExciseTaxes}
                      onChange={this.onChange(
                        'enableApplicableExciseTaxes',
                        enableApplicableExciseTaxes,
                      )}
                      valueToRender={enableApplicableExciseTaxes ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Total Tax</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableTotalTaxORGranularTax}
                      onChange={this.onChange(
                        'enableTotalTaxORGranularTax',
                        enableTotalTaxORGranularTax,
                      )}
                      valueToRender={enableTotalTaxORGranularTax ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Applicable Promotion Name(s)</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableApplicablePromotionsName}
                      onChange={this.onChange(
                        'enableApplicablePromotionsName',
                        enableApplicablePromotionsName,
                      )}
                      valueToRender={enableApplicablePromotionsName ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Applicable Reward Name(s)</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableApplicableRewardsName}
                      onChange={this.onChange(
                        'enableApplicableRewardsName',
                        enableApplicableRewardsName,
                      )}
                      valueToRender={enableApplicableRewardsName ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Applicable Order Tags</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableApplicableOrderTags}
                      onChange={this.onChange(
                        'enableApplicableOrderTags',
                        enableApplicableOrderTags,
                      )}
                      valueToRender={enableApplicableOrderTags ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Paid Status</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enablePaidStatus}
                      onChange={this.onChange('enablePaidStatus', enablePaidStatus)}
                      valueToRender={enablePaidStatus ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <Grid item xs={12} sm={12} md={12} lg={12} className="margin-top-small">
              <Typography variant="headline" gutterBottom>
                Product Info:
              </Typography>
            </Grid>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Name</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableProductName}
                      onChange={this.onChange('enableProductName', enableProductName)}
                      valueToRender={enableProductName ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Brand</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableBrand}
                      onChange={this.onChange('enableBrand', enableBrand)}
                      valueToRender={enableBrand ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Price</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableProductsValue}
                      onChange={this.onChange('enableProductsValue', enableProductsValue)}
                      valueToRender={enableProductsValue ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Discount</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableDiscount}
                      onChange={this.onChange('enableDiscount', enableDiscount)}
                      valueToRender={enableDiscount ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Discount Notes</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableDiscountNotes}
                      onChange={this.onChange('enableDiscountNotes', enableDiscountNotes)}
                      valueToRender={enableDiscountNotes ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>WPU</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableWPU}
                      onChange={this.onChange('enableWPU', enableWPU)}
                      valueToRender={enableWPU ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>SKU</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableProductSKU}
                      onChange={this.onChange('enableProductSKU', enableProductSKU)}
                      valueToRender={enableProductSKU ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Unique #</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableBatchUID}
                      onChange={this.onChange('enableBatchUID', enableBatchUID)}
                      valueToRender={enableBatchUID ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Batch Tracking System Tag</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableBatchTrackingSystemLabel}
                      onChange={this.onChange(
                        'enableBatchTrackingSystemLabel',
                        enableBatchTrackingSystemLabel,
                      )}
                      valueToRender={enableBatchTrackingSystemLabel ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
          </Grid>
        </div>
      </ExpansionPanelDetails>
    )
  }
}

export default connect(({ dispatch }) => ({ dispatch }))(OnFleetSettingInfoOrdenNotes)



// WEBPACK FOOTER //
// ./src/components/OnFleet/OnFleetSettingInfoOrdenNotes.js